import type { ChangeEvent } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'
import type { BranchForForm } from 'types'

import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TextInput } from 'components'
import { trimFirstSpace } from 'helpers/common'

interface IInputPostalCode {
  field: ControllerRenderProps
}

export const InputEmail: React.FC<IInputPostalCode> = ({ field }) => {
  const { errors, setValue, watch, trigger, getValues } =
    useFormContext<BranchForForm>()

  const { isSameAsCompany } = watch(['isSameAsCompany'])

  const { t } = useTranslation(['common'])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.onChange(trimFirstSpace(e))
  }

  const onBlur = async () => {
    setValue('email', getValues('email').trim())
    await trigger('email')
  }

  return (
    <TextInput
      value={field.value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={t('common:email.placeholder')}
      disabled={isSameAsCompany}
      isError={Boolean(errors.email?.message)}
      message={errors.email?.message}
      maxLength={50}
      ref={field.ref}
    />
  )
}
